import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Select2 from "@Shared/components/inputs/select2";
import { CLIENT_APPLICATION_STATUS } from "@Shared/js/enum";
import { upperFirst } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationStatusSelectFilter",
  components: {
    Select2
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: null,
      default: ""
    },
    data: {
      type: [Object, Array],
      default: null
    },
    colorDegree: {
      type: [String, Number],
      default: 0
    },
    multiple: {
      type: Boolean,
      default: false
    },
    statusType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      select2Options: {}
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initSelect2();
    });
  },
  methods: {
    getSelect2Options() {
      return {
        placeholder: this.placeholder,
        dropdownCssClass: this.name + "-select",
        closeOnSelect: this.multiple ? false : true
      };
    },
    handleSelect2Change(data) {
      this.$emit("change", data);
    },
    initSelect2() {
      this.$nextTick(() => {
        this.select2Options = this.getSelect2Options();
        this.$refs.select.initSelect2();
      });
    },
    formatData(data) {
      return data && _mapInstanceProperty(data).call(data, status => {
        const text = this.$t(`application.${this.statusType}.${status}`);
        return {
          text: upperFirst(text),
          id: CLIENT_APPLICATION_STATUS[status] || status
        };
      });
    }
  }
});